export const TENANTS_LISTING_CONFIG = {
  basePath: "/tenants",
  pageSize: 10,
  staleTimeMs: 120_000,
  gcTimeMs: 600_000,
} as const;
